import * as React from "react";

export const LevelSeven = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={44}
    height={44}
    fill="none"
    {...props}
  >
    <circle cx={22} cy={22} r={22} fill="#169FED" />
    <path
      fill="#fff"
      d="M26.466 13.16v3.115H19.34V29.29H15.04V16.275H9.217V13.16h17.249Z"
    />
    <path
      fill="#fff"
      d="M9.218 31.4v-3.115h6.047V15.27h4.302v13.015h6.9V31.4H9.217Z"
    />
    <path
      fill="#fff"
      d="M33.743 13.16v3.115h-5.778V29.29h-4.301V16.275h-6.9V13.16h16.98Z"
    />
    <path
      fill="#fff"
      d="M16.765 31.4v-3.114h7.125V15.27h4.302v13.016h6.091V31.4H16.765Z"
    />
  </svg>
);
